import { AxiosResponse } from "axios";
import {
  CreateVideoRequest,
  UpdateVideoRequest,
  VideoResponse,
} from "../models/video";
import { backend } from "../utils/axios";

const ROUTE = "/videos";

interface VideosServiceEndpoints {
  getAll: () => Promise<VideoResponse[]>;
  create: (data: CreateVideoRequest) => Promise<VideoResponse>;
  getByElectionType: (electionTypeId: string) => Promise<VideoResponse>;
  getById: (id: string) => Promise<VideoResponse>;
  update: (id: string, data: UpdateVideoRequest) => Promise<VideoResponse>;
  delete: (id: string) => Promise<VideoResponse>;
}

export const VideosService: VideosServiceEndpoints = {
  getAll: () =>
    backend
      .get<VideoResponse[]>(ROUTE)
      .then(({ data }) => data)
      .catch(),
  create: (data) =>
    backend
      .post<CreateVideoRequest, AxiosResponse<VideoResponse>>(ROUTE, data)
      .then(({ data }) => data)
      .catch(),
  getByElectionType: (electionTypeId) =>
    backend
      .get<VideoResponse>(`${ROUTE}/by-election-type/${electionTypeId}`)
      .then(({ data }) => data)
      .catch(),
  getById: (id) =>
    backend
      .get<VideoResponse>(`${ROUTE}/${id}`)
      .then(({ data }) => data)
      .catch(),
  update: (id, data) =>
    backend
      .put<UpdateVideoRequest, AxiosResponse<VideoResponse>>(
        `${ROUTE}/${id}`,
        data
      )
      .then(({ data }) => data)
      .catch(),
  delete: (id) =>
    backend
      .delete<VideoResponse>(`${ROUTE}/${id}`)
      .then(({ data }) => data)
      .catch(),
};
